import React, {Component} from 'react';
import {Formik} from "formik";
import {BootstrapError, BootstrapField} from "../../helpers/Field";
import * as yup from 'yup';
import {connect} from "react-redux";
import {IntlShape, useIntl} from "react-intl";


function schema(t: IntlShape) {
    return yup.object().shape({
        primary_account: yup.string()
            .matches(/^[a-zA-Z0-9]*$/, t.formatMessage({id: "errors.invalid_characters"}))
            .required(t.formatMessage({id: "errors.required"})),
        account_type: yup.string()
            .required(t.formatMessage({id: "errors.required"})),
        sales_organization: yup.string()
            .matches(/^[a-zA-Z0-9]*$/, t.formatMessage({id: "errors.invalid_characters"}))
            .required(t.formatMessage({id: "errors.required"})),
        company_code: yup.string()
            .matches(/^[a-zA-Z0-9]*$/, t.formatMessage({id: "errors.invalid_characters"}))
            .required(t.formatMessage({id: "errors.required"})),
        division: yup.string()
            .matches(/^[a-zA-Z0-9]*$/, t.formatMessage({id: "errors.invalid_characters"}))
            .required(t.formatMessage({id: "errors.required"})),
        distribution_channel: yup.string()
            .matches(/^[a-zA-Z0-9]*$/, t.formatMessage({id: "errors.invalid_characters"}))
            .required(t.formatMessage({id: "errors.required"}))
    });
}

function ManageUserSapAccount(props: any) {

    const intl = useIntl();
    const t = (id:string) => intl.formatMessage({id: id});

    let _salesOrgs: any = {};
    props.salesOrgs?.filter(_ => _.active && _.active === "X").forEach(_ => _salesOrgs[_.sales_organization] = _.sales_organization);
    _salesOrgs = Object.keys(_salesOrgs);


    // Formik needs properties as empty strings instead of null.
    for (let propertyName in props.account) {
        if (props.account[propertyName] === null) {
            props.account[propertyName] = ""
        }
    }

    return (
        <div>
            <Formik
                validationSchema={schema(intl)}
                onSubmit={(values, bag) => {
                    bag.setSubmitting(true);
                    props.saveAccount(values).then(() => {
                        // bag.setSubmitting(false);
                    })
                }}
                initialValues={props.account}
                enableReinitialize={true}
                render={(formProps: any) =>
                    <form onSubmit={formProps.handleSubmit}>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group d-flex flex-row">
                                    <label className="wa-label col-form-label pr-2">{t("sap.account")}</label>
                                    <div className="flex-grow-1">
                                        <BootstrapField type="text" name="primary_account"
                                                        placeholder={t("sap.account")}/>
                                        {/*<BootstrapError name="primaryAcct"/>*/}
                                    </div>
                                </div>
                                {props.accountTypes.length > 1 && <div className="form-group d-flex flex-row">
                                  <label
                                    className="wa-label col-form-label pr-2 text-nowrap">{t("sap.account_type")}</label>
                                  <div className="flex-grow-1">
                                    <BootstrapField component="select" name="account_type"
                                                    value={formProps.values.account_type}>
                                      <option value="" disabled selected={true}>{t("sap.account_type")}</option>
                                        {props.accountTypes.map(accountType => {
                                            return (
                                                <option value={accountType.accountTypeId}
                                                        key={accountType.accountTypeId}>
                                                    {accountType.accountTypeValue}
                                                </option>
                                            )
                                        })}
                                    </BootstrapField>
                                    <BootstrapError name="account_type"/>
                                  </div>
                                </div>}
                                <div className="form-group d-flex flex-row">
                                    <label
                                        className="wa-label col-form-label pr-2 text-nowrap">{t("sap.company_code")}</label>
                                    <div className="flex-grow-1">
                                        <BootstrapField component="select" name="company_code">
                                            <option value="" disabled selected={true}>{t("sap.company_code")}</option>
                                            {props.companyCodes?.filter(_ => _.active && _.active === "X").map(_ => {
                                                return (
                                                    <option value={_.company_code} key={_.company_code}>
                                                        {_.company_code}
                                                    </option>
                                                )
                                            })}
                                        </BootstrapField>
                                        <BootstrapError name="companyCode"/>
                                    </div>
                                </div>
                                <div className="form-group d-flex flex-row">
                                    <label
                                        className="wa-label col-form-label pr-2 text-nowrap">{t("sap.sales_organization")}</label>
                                    <div className="flex-grow-1">
                                        <BootstrapField component="select" name="sales_organization">
                                            <option value="" disabled
                                                    selected={true}>{t("sap.sales_organization")}</option>
                                            {_salesOrgs.map(sales_organization => {
                                                return (
                                                    <option value={sales_organization} key={sales_organization}>
                                                        {sales_organization}
                                                    </option>
                                                )
                                            })}
                                        </BootstrapField>
                                        <BootstrapError name="sales_organization"/>
                                    </div>
                                </div>
                                <div className="form-group d-flex flex-row">
                                    <label
                                        className="wa-label col-form-label pr-2 text-nowrap">{t("sap.distribution_channel")}</label>
                                    <div className="flex-grow-1">
                                        <BootstrapField type="text" name="distribution_channel"
                                                        placeholder={t("sap.distribution_channel")}/>
                                        <BootstrapError name="distribution_channel"/>
                                    </div>
                                </div>
                                <div className="form-group d-flex flex-row">
                                    <label className="wa-label col-form-label pr-2 text-nowrap">Company Division</label>
                                    <div className="flex-grow-1">
                                        <BootstrapField type="text" name="division" placeholder={"Company Division"}/>
                                        <BootstrapError name="division"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <button type="submit" className={"btn btn-primary"}>Save</button>
                        </div>
                    </form>
                }/>
        </div>
    );
}

export default connect<any, any, any, any>((store, props) => ({
    salesOrgs: store.app.config.sap.data?.sales_area_data,
    companyCodes: store.app.config.sap.data?.company_codes,
}))(ManageUserSapAccount);
